export enum PaymentFrequency {
    Monthly = 1,
    Quarterly = 4,
    Biannually = 6,
    Annually = 12
}

export const CreditCard = 'Credit Card';

export const DirectDebit = 'Direct Debit';

export interface DirectDebitDetails {
    kind: 'directdebit';
    accountHolderName: string;
    accountNumber: string;
    sortCode: string;
    paymentDay: number;
    paymentFrequency: PaymentFrequency;
}

export default DirectDebitDetails;



// WEBPACK FOOTER //
// ./src/Models/Payment/DirectDebit/index.ts